<template>
  <div class="wrapper">
    <!-- <myHeader
      style="width: 100%; position: relative"
      :GROUP_NAME="GROUP_NAME"
      :sidebar_show="sidebar_show"
      @sidebar_show_click="sidebar_show_click"
    >
    </myHeader> -->
    <MyAlert ref="c_alert" style="
        width: 300px;
        position: absolute;
        z-index: 9999;
        left: calc(50% + -150px);
      ">
    </MyAlert>
    <div id="overflow_div" class="flex-grow-1">
      <!-- style="height: 100%; width: 100%; position: fixed; background: #fffff9; overflow: auto;" -->
      <div style="height: 100%">
        <router-view @Msg="Msg" />
        <b-overlay :show="overlay" opacity="0.6" no-wrap style="z-index: 9000">
          <template #overlay>
            <div class="d-flex align-items-center">
              <b-spinner type="grow" variant="secondary"></b-spinner>
              <b-spinner type="grow" variant="secondary"></b-spinner>
              <b-spinner type="grow" variant="secondary"></b-spinner>
              <!-- We add an SR only text for screen readers -->
              <span class="sr-only">Please wait...</span>
            </div>
          </template>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/MyModule/NavHeader';
import Alert from '@/components/MyModule/alert';
import MainPageVue from './View/MainPage.vue';
export default {
  name: 'Home',
  data() {
    return {
      b_items: [
        {
          text: 'Home',
          to: { name: 'control_center' }
        }
      ],
      overlay: false,
      GROUP_NAME: '',
      sidebar_show: true
    };
  },
  watch: {
    $route: function () {
      this.sidebar_show = false;
    }
  },
  mounted() {
    // this.$cookieFunc.setCookie(
    //   'Userid',
    //   this.$Global.Base64Utils.utoa('123'),
    //   60 * 60 * 24 * 30
    // );
    // this.$cookieFunc.setCookie(
    //   'ShopNO',
    //   this.$Global.Base64Utils.utoa('B001'),
    //   60 * 60 * 24 * 30
    // );
    // this.$cookieFunc.setCookie(
    //   'uAugroup',
    //   this.$Global.Base64Utils.utoa('餐廳'),
    //   60 * 60 * 24 * 30
    // );
    // this.$cookieFunc.setCookie(
    //   'Homeid',
    //   this.$Global.Base64Utils.utoa('1'),
    //   60 * 60 * 24 * 30
    // );
    // this.$cookieFunc.setCookie(
    //   'UserName',
    //   this.$Global.Base64Utils.utoa('123'),
    //   60 * 60 * 24 * 30
    // );
    // this.$cookieFunc.setCookie(
    //   'Mobile',
    //   this.$Global.Base64Utils.utoa('0900111222'),
    //   60 * 60 * 24 * 30
    // );

    if (this.$route.name == "Home") {
      this.$router.push({
        name: 'MainPage'
      });
    }
  },
  methods: {
    Msg(msg, sec, type) {
      this.$refs.c_alert.showAlert(sec, msg, type);
    },
    Breadcrumb_change(reserve, name, page) {
      //console.log("AAA")
      this.b_items.splice(reserve);
      this.b_items.push({
        text: name,
        to: { name: page }
      });
    },
    sidebar_show_click() {
      this.sidebar_show = !this.sidebar_show;
    }
  },
  components: {
    MyAlert: Alert,
    myHeader: Header
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

#overflow_div {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue